module.exports = __webpack_public_path__ + "assets/img/kv-c4f57f3f.jpg";